import { createApi, retry } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '~/api/axiosBaseQuery';

const staggeredBaseQuery = retry(axiosBaseQuery(), {
  maxRetries: 0,
});

export const easyEstimatorApi = createApi({
  reducerPath: 'easyEstimatorApi',
  baseQuery: staggeredBaseQuery,
  endpoints: () => ({}),
});
